/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/growth.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.Growth
 */
export interface Growth {
    /**
     * @generated from protobuf field: optional string cta_name = 1;
     */
    cta_name?: string;
    /**
     * @generated from protobuf field: optional string cta_coordinates = 2;
     */
    cta_coordinates?: string;
    /**
     * @generated from protobuf field: optional string cta_description = 3;
     */
    cta_description?: string;
    /**
     * @generated from protobuf field: optional string container_name = 4;
     */
    container_name?: string;
    /**
     * @generated from protobuf field: optional string container_coordinates = 5;
     */
    container_coordinates?: string;
    /**
     * @generated from protobuf field: optional int32 container_index = 6;
     */
    container_index?: number;
    /**
     * @generated from protobuf field: optional string tab_name = 7;
     */
    tab_name?: string;
    /**
     * @generated from protobuf field: optional string tab_coordinates = 8;
     */
    tab_coordinates?: string;
    /**
     * @generated from protobuf field: optional int32 tab_index = 9;
     */
    tab_index?: number;
    /**
     * @generated from protobuf field: optional int32 offer_sequence_position = 10;
     */
    offer_sequence_position?: number;
    /**
     * @generated from protobuf field: optional int32 offers_returned = 11;
     */
    offers_returned?: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class Growth$Type extends MessageType<Growth> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.Growth", [
            { no: 1, name: "cta_name", kind: "scalar", localName: "cta_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "sign_in, sign_up, help, learn more, details, add ons skipped etc", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "sign_in, sign_up, help, learn more, details, add ons skipped etc." } },
            { no: 2, name: "cta_coordinates", kind: "scalar", localName: "cta_coordinates", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "location coordinates of the button, link." } },
            { no: 3, name: "cta_description", kind: "scalar", localName: "cta_description", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "description of the location of button, link such as top left or test button/control button." } },
            { no: 4, name: "container_name", kind: "scalar", localName: "container_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "pro, elite, premier, latino, most_popular, premium_channels etc", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "pro, elite, premier, latino, most_popular, premium_channels etc." } },
            { no: 5, name: "container_coordinates", kind: "scalar", localName: "container_coordinates", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "location coordinates of the card", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "location coordinates of the card." } },
            { no: 6, name: "container_index", kind: "scalar", localName: "container_index", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "index starting with 0." } },
            { no: 7, name: "tab_name", kind: "scalar", localName: "tab_name", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "pro, elite, premier, latino etc", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "pro, elite, premier, latino etc." } },
            { no: 8, name: "tab_coordinates", kind: "scalar", localName: "tab_coordinates", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "NA", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "location coordinates of the tab." } },
            { no: 9, name: "tab_index", kind: "scalar", localName: "tab_index", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "index starting with 0." } },
            { no: 10, name: "offer_sequence_position", kind: "scalar", localName: "offer_sequence_position", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "This offer in consecutive sequence is the offer in question." } },
            { no: 11, name: "offers_returned", kind: "scalar", localName: "offers_returned", opt: true, T: 5 /*ScalarType.INT32*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "The number of events user have seen in total based on the eligibility." } }
        ]);
    }
    create(value?: PartialMessage<Growth>): Growth {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Growth>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Growth): Growth {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string cta_name */ 1:
                    message.cta_name = reader.string();
                    break;
                case /* optional string cta_coordinates */ 2:
                    message.cta_coordinates = reader.string();
                    break;
                case /* optional string cta_description */ 3:
                    message.cta_description = reader.string();
                    break;
                case /* optional string container_name */ 4:
                    message.container_name = reader.string();
                    break;
                case /* optional string container_coordinates */ 5:
                    message.container_coordinates = reader.string();
                    break;
                case /* optional int32 container_index */ 6:
                    message.container_index = reader.int32();
                    break;
                case /* optional string tab_name */ 7:
                    message.tab_name = reader.string();
                    break;
                case /* optional string tab_coordinates */ 8:
                    message.tab_coordinates = reader.string();
                    break;
                case /* optional int32 tab_index */ 9:
                    message.tab_index = reader.int32();
                    break;
                case /* optional int32 offer_sequence_position */ 10:
                    message.offer_sequence_position = reader.int32();
                    break;
                case /* optional int32 offers_returned */ 11:
                    message.offers_returned = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Growth, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string cta_name = 1; */
        if (message.cta_name !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.cta_name);
        /* optional string cta_coordinates = 2; */
        if (message.cta_coordinates !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.cta_coordinates);
        /* optional string cta_description = 3; */
        if (message.cta_description !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.cta_description);
        /* optional string container_name = 4; */
        if (message.container_name !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.container_name);
        /* optional string container_coordinates = 5; */
        if (message.container_coordinates !== undefined)
            writer.tag(5, WireType.LengthDelimited).string(message.container_coordinates);
        /* optional int32 container_index = 6; */
        if (message.container_index !== undefined)
            writer.tag(6, WireType.Varint).int32(message.container_index);
        /* optional string tab_name = 7; */
        if (message.tab_name !== undefined)
            writer.tag(7, WireType.LengthDelimited).string(message.tab_name);
        /* optional string tab_coordinates = 8; */
        if (message.tab_coordinates !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.tab_coordinates);
        /* optional int32 tab_index = 9; */
        if (message.tab_index !== undefined)
            writer.tag(9, WireType.Varint).int32(message.tab_index);
        /* optional int32 offer_sequence_position = 10; */
        if (message.offer_sequence_position !== undefined)
            writer.tag(10, WireType.Varint).int32(message.offer_sequence_position);
        /* optional int32 offers_returned = 11; */
        if (message.offers_returned !== undefined)
            writer.tag(11, WireType.Varint).int32(message.offers_returned);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.Growth
 */
export const Growth = new Growth$Type();
